import { RingLoader } from "react-spinners";
// import TransparentHeader from "./TransparentHeader";
import Header from "./Header";

export const Loader = ({ color }) => {
  return (
    <div>
      {/* <TransparentHeader /> */}
      <Header/>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <RingLoader
          color={color ? color : "#82aae3"}
          cssOverride={{}}
          loading
          size={90}
          speedMultiplier={0.5}
        />
      </div>
    </div>
  );
};
